import validate from "validate.js";
import { isNullOrUndefined } from "./DefineFunction";
/**
 * 特定のフィールドに対する Validation を実行するクラスです。
 */
export class ValidationField {
    key;
    model;
    constraints;
    modified = false;
    beforeValue = "";
    customMessage = "";
    /**
     * コンストラクタ
     * @param key 検証項目名 -> 検証対象となるmodelのプロパティ名
     * @param model 検証model
     * @param constraints 検証に必要なvalidator定義
     */
    constructor(key, model, constraints) {
        this.key = key;
        this.model = model;
        this.constraints = constraints;
    }
    /** 検証エラーメッセージを取得します。 */
    get errors() {
        let result = this.validate();
        return result ?? [];
    }
    /** 検証エラーが発生しているかどうかを取得します。 */
    get error() {
        return this.errors.length > 0;
    }
    /**
     * バリデーションエラーメッセージを取得します。
     * エラーが発生していない場合は空文字が返ります。
     */
    get message() {
        let errors = this.errors;
        return errors.length > 0 ? errors[0] : "";
    }
    /** 検証エラーをリセットします。 */
    reset() {
        this.customMessage = "";
        this.modified = false;
        this.beforeValue = this.model[this.key];
    }
    /** エラーメッセージをセットします。 */
    set(message) {
        if (message) {
            this.customMessage = message;
            this.modified = true;
        }
    }
    /** 検証を実行します */
    validate() {
        if (!this.isModified()) {
            return null;
        }
        // singleだと単一の入力項目しか参照できないので、
        // validateでmodel全体を参照し、
        // 検証対象分だけ切り出したconstraintsを指定することで対象項目のみ検証する。
        let targets = {};
        targets[this.key] = this.constraints[this.key];
        let result = validate(this.model, targets, { fullMessages: false });
        // エラーメッセージ配列のみ返す
        if (result?.[this.key]) {
            return result[this.key];
        }
        if (this.customMessage) {
            return [this.customMessage];
        }
        return null;
    }
    isModified() {
        if (this.modified) {
            return this.modified;
        }
        let value = this.model;
        let keys = this.key.split(".");
        for (let key of keys) {
            value = value[key];
        }
        if (!isNullOrUndefined(value) && this.beforeValue !== value) {
            this.modified = true;
        }
        return this.modified;
    }
}
